import DatatableHelperMixin from "../../../../../common/Mixin/Global/DatatableHelperMixin";
import {INVOICE_LIST,INVOICE_VIEW, ORDER_MAX_MIN_PRICE, GENERATE_INVOICE_VIEW, GENERATE_PERFOMA_INVOICE_VIEW} from "../../../../Config/ApiUrl-CP";
import {axiosGet, urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import SelectableStatusMixin from "../../../../Helper/SelectableOptions/SelectableStatusMixin";
import {mapGetters} from "vuex";
import {numberWithCurrencySymbol} from "../../../../Helper/Helper";


export default {
    mixins: [DatatableHelperMixin,SelectableStatusMixin],
    data() {
        return {
            options: {
                name: this.$t('invoice'),
                url: null,
                showCount: true,
                showClearFilter: true,
                showHeader: true,
                columns: [
                    {
                        title: this.$t('Order No.'),
                        type: 'component',
                        key: 'invoice_number',
                        componentName: 'app-invoice-number'
                    },
                    {
                        title: this.$t('Invoice No.'),
                        type: 'custom-html',
                        key: 'invoice_gen_number',
                        modifier: (invoice_gen_number,row) => invoice_gen_number ? `<a href="${urlGenerator(GENERATE_INVOICE_VIEW+row.id)}" class="redirectTo">${invoice_gen_number}</a>` :'-',
                    },
                    {
                        title: this.$t('Proforma No.'),
                        type: 'custom-html',
                        key: 'perfoma_gen_number',
                        modifier: (perfoma_gen_number,row) => perfoma_gen_number ? `<a href="${urlGenerator(GENERATE_PERFOMA_INVOICE_VIEW+row.id)}" class="redirectTo">${perfoma_gen_number}</a>` :'-',
                    },
                    {
                        title: this.$t('Order Branch'),
                        type: 'custom-html',
                        key: 'branch_or_warehouse',
                        modifier: value => value ? `<span>${value.name} <span class="text-${ value.type.toLowerCase() === 'branch' ? 'warning' : 'info' }">(${value.type[0].toUpperCase()})</span></span>` : ''
                    },
                    {
                        title: this.$t('biller'),
                        type: 'object',
                        key: 'created_by',
                        modifier : (created_by) => (created_by?.full_name)
                    },
                    {
                        title: this.$t('customer'),
                        type: 'custom-html',
                        key: 'customer',
                        modifier: (row) => row?.full_name ? `<a href="${urlGenerator('customer/view/'+row?.id)}" class="redirectTo">${row.full_name}</a>` :'-',
                    },
                    {
                        title: this.$t('total_amount'),
                        type: 'custom-html',
                        key: 'grand_total',
                        titleAlignment: 'right',
                        modifier: value => `<p class="text-right mb-0">${value ? numberWithCurrencySymbol(value) : 0}</p>`,
                    },
                    {
                        title: this.$t('paid_amount'),
                        type: 'custom-html',
                        key: 'paid_amount',
                        titleAlignment: 'right',
                        modifier: value => `<p class="text-right mb-0">${value ? numberWithCurrencySymbol(value) : 0}</p>`,
                    },
                    {
                        title: this.$t('due_amount'),
                        type: 'custom-html',
                        key: 'due_amount',
                        titleAlignment: 'right',
                        modifier: value => `<p class="text-right mb-0">${value ? numberWithCurrencySymbol(value) : 0}</p>`,
                    },
                    {
                        title: this.$t('payment_note'),
                        type: 'component',
                        componentName: 'app-payment-note-column',
                        key: 'payment_note',
                    },
                    {
                        title: this.$t('payment_methods'),
                        type: 'object',
                        key: 'payment_mode',
                        modifier: value => value?.item_label,
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: (value) => {
                            return `<span class="badge badge-pill badge-${value.class}">${value.translated_name}</span>`;
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        key: 'invoice',
                        isVisible: true
                    },
                ],
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('view'),
                        type: 'view'
                    },
                    {
                        title: this.$t('Download Invoice'),
                        type: 'download_invoice',
                        modifier: () => this.$can('manage_generate_sales_invoice')
                    },
                    {
                        title: this.$t('Download Proforma Invoice'),
                        type: 'download_perfoma_invoice',
                        modifier: () => this.$can('manage_generate_proforma_invoice')
                    },
                    {
                        title: this.$t('Print Order Confirmation'),
                        type: 'print_order_confirmation',
                        modifier: () => this.$can('manage_generate_order_confirmation')
                    },
                    {
                        title: this.$t('due_receive'),
                        type: 'due_receive',
                        modifier: (row) => {
                            if(this.$can('orders_due_payment')) {
                                return row.due_amount > 0 ? true : false
                            } else {
                                return false;
                            }
                        }
                    }
                ],
                filters: [
                    {
                        title: this.$t('issue_date'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear", "lastYear"]
                    },
                    {
                        title: this.$t('customer'),
                        type: 'search-and-select-filter',
                        key: 'customers',
                        settings: {
                            url: urlGenerator('app/selectable-customers'),
                            modifire: ({id, full_name}) => ({id, full_name}),
                            params: {},
                            per_page: 10,
                            queryName: 'search',
                            loader: 'app-pre-loader'
                        },
                        listValueField: 'full_name'
                    },
                    {
                        title: "Price Range",
                        type: "range-filter",
                        key: "range_filter",
                        maxTitle: "Max usd",
                        minTitle: "Min usd",
                        sign: "₹",
                        minRange:0,
                        maxRange:0,
                    },
                    this.getStatusFilterOptions('order'),
                    {
                        title: this.$t('All Branchs'),
                        type: 'checkbox',
                        key: 'all_branch',
                        option: [
                            { id: 'Yes', value: this.$t('Yes') },
                            { id: 'No', value: this.$t('No') },
                        ],
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                search: true,
            },
            orderMaxMinPriceUrl:''
        }
    },
    methods:{
        getMaxMinOrderPrice() {
            axiosGet(this.orderMaxMinPriceUrl).then((res) => {
                this.options?.filters.find(({key}) => {
                    if (key === 'range_filter') {
                        Object.assign(this.options.filters[2], res.data)
                    }
                })
            })
        },

        updateOrderMaxMinPriceUrl() {
            this.orderMaxMinPriceUrl = `${ORDER_MAX_MIN_PRICE}?branch_or_warehouse_id=${this.getBranchOrWarehouseId}`
        },
        updateUrl(baseUrl, callback){
            const branchIdOnLocalStorage = localStorage.getItem('currentBranchWahrehouseId');
            this.options.url = `${baseUrl}?from=invoice&branch_or_warehouse_id=${branchIdOnLocalStorage ?? this.getBranchOrWarehouseId}`
            if (callback) callback();
            this.$hub.$emit(`reload-${this.table_id}`)
        }

      
    },
    computed:{
        ...mapGetters(['getBranchOrWarehouseId']),
    },
    mounted(){
        this.updateUrl(INVOICE_LIST, this.updateOrderMaxMinPriceUrl);
        $(document).on('click','.redirectTo',function(){
            window.open($(this).attr('href'),'_blank');
        });
    },
    watch: {
        getBranchOrWarehouseId(){
            this.updateUrl(INVOICE_LIST, this.updateOrderMaxMinPriceUrl);
            this.getMaxMinOrderPrice();
            this.$hub.$emit(`reload-${this.table_id}`)
        },
    }
}
